/**
 * Diacritic- and case-insensitive search key. Locale-INDEPENDENT: `toLowerCase()`
 * (never `toLocaleLowerCase()`) then strip combining marks, so "İzin" → "izin" and
 * "Süreci" → "sureci". Without the NFD pass, lowercasing "İ" yields "i" + U+0307
 * (a combining dot) and a user typing "izin" — or searching "MUSTERİ" against
 * "Musteri" with a Turkish-caps keyboard — would match nothing (KOA-18293 B5).
 *
 * Use this for every type-to-filter search over user-named things; a plain
 * `toLowerCase().includes()` is wrong the moment a Turkish İ appears on either side.
 *
 * NOT INTERCHANGEABLE with `foldForScreenNameMatch`
 * (`shared/utility/workflow-step-screen-mapping.ts`), which looks like it answers the same
 * question and does not. This one is a SEARCH key: it leaves the dotless `ı` alone, because
 * a person typing `ı` means `ı` and a filter that folded it would match things they did not
 * ask for. That one is an IDENTITY key for comparing two GENERATED names, where `ı` and `i`
 * are the same letter surviving two different transliterations, so it must fold them.
 * Borrowing either for the other's job breaks it silently — the step↔screen pairing has
 * already been rotated once by a name comparison that was almost right. The divergence is
 * pinned by a test.
 */
export const normalizeForSearch = (value: string): string =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
